import type { MediaType } from '@src/model/frontendmodel';
import type { TimelineEvent } from '@types';

/**
 * Normalizes, in place, a timeline event fetched from the chat-timeline history endpoint:
 * - `mediaType` defaults to the event type, which is what decides the bubble renderer.
 * - A `CONTACT_PHONE_LINKED` item carries its id as `id`, while the live push maps it to
 *   `messageId` (ENG-1304); copying it lets the timeline dedupe the two by `messageId`.
 */
const normalizeTimelineEvent = (event: TimelineEvent): TimelineEvent => {
  if (!event?.mediaType) event.mediaType = event.type as MediaType;
  if (event.type === 'CONTACT_PHONE_LINKED' && !event.messageId) {
    event.messageId = (event as { id?: string }).id as string;
  }
  return event;
};

export default normalizeTimelineEvent;
